var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.open,
            title: "Change Benefit",
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "table_box" },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.tableData } },
                [
                  _c("el-table-column", {
                    attrs: { label: "No.", align: "center", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.tnEthAccount ===
                            _vm.$store.getters.metaMaskObj.account
                              ? _c("svg-icon", {
                                  attrs: { "icon-class": "share_user" },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.$index + 1) +
                                "\n            "
                            ),
                            scope.row.tnEthAccount ===
                            _vm.$store.getters.metaMaskObj.account
                              ? _c("span", [_vm._v("(YOU)")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "tnEthAccount", label: "Beneficiar" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.isOld
                              ? _c("span", [_vm._v(_vm._s(row.tnEthAccount))])
                              : _c("el-input", {
                                  attrs: { disabled: !row.isEdit },
                                  model: {
                                    value: row.tnEthAccount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        row,
                                        "tnEthAccount",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "row.tnEthAccount",
                                  },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ratio",
                      label: "Benefit ratio",
                      width: "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.isOld
                              ? _c("span", [_vm._v(_vm._s(row.ratio) + " %")])
                              : _c(
                                  "el-input",
                                  {
                                    on: {
                                      change: function ($event) {
                                        return _vm.getOwnRatio(row)
                                      },
                                    },
                                    model: {
                                      value: row.ratio,
                                      callback: function ($$v) {
                                        _vm.$set(row, "ratio", _vm._n($$v))
                                      },
                                      expression: "row.ratio",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.tnEthAccount ===
                              _vm.$store.getters.metaMaskObj.account &&
                            _vm.tableData.length < 10
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAdd(scope.$index)
                                      },
                                    },
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: { "icon-class": "share_add" },
                                    }),
                                    _vm._v(
                                      "\n              Share\n            "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !scope.row.isOld ||
                            (scope.row.ratio == 0 && _vm.isOwner)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDel(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Delete\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tip" }, [
            _c("p", [_vm._v("Tips:")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        1. Please ensure that the beneficiary's account is true, accurate, and carefully\n        distributed; "
              ),
              _c("br"),
              _vm._v(
                "\n        2. After the Rep is minted successfully, it will be automatically sent to the\n        beneficiary's account according to the ratio you set.\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleCancel()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnloading },
                  on: {
                    click: function ($event) {
                      return _vm.handleSubmite()
                    },
                  },
                },
                [_vm._v("\n        Confirm\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: "Choose a beneficiary",
            width: "450px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.stepType === 1
            ? _c("p", [
                _vm._v("Do you want to divide the benefits to a certain DAPP?"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.stepType === 2
            ? _c(
                "div",
                [
                  _c("p", [_vm._v("Divide the beneficiary ratio to DAPP")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.DappRadio,
                        callback: function ($$v) {
                          _vm.DappRadio = $$v
                        },
                        expression: "DappRadio",
                      },
                    },
                    _vm._l(_vm.dappList, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.name, attrs: { label: item.account } },
                        [_vm._v("\n          Defi\n        ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.stepType === 1
                ? [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.selectedDapp("no")
                          },
                        },
                      },
                      [_vm._v("No")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.selectedDapp("yes")
                          },
                        },
                      },
                      [_vm._v("Yes")]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.stepType === 2
                ? [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.selectedDapp("back")
                          },
                        },
                      },
                      [_vm._v("Back")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: !_vm.DappRadio },
                        on: {
                          click: function ($event) {
                            return _vm.selectedDapp("submit")
                          },
                        },
                      },
                      [_vm._v("Submit")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }